import React from "react";
import './Products.css';

function Products() {
  // console.log("get into Products()");
  return (
    <div className='products-page'>
      <header className='mt-5'>
        <div className='container h-100 d-flex align-items-center justify-content-center'>
          <h1 className='text-light'>Products</h1>
        </div>
      </header>
    </div>
  );
}

export default Products;